<template>
  <div>
    <b-modal id="modalEditTimeRanges" ref="modalEditTimeRanges" :title="$t('Time ranges')" hide-footer size="xl">
      <div v-if="editItem">
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Priority')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="editItem.priority"/>
        </b-form-group>
        <b-button variant="success" class="mb-2" size="sm" @click="addWDays">{{ $t('Add') }}</b-button>
        <b-card class="mb-2">
          <b-row>
            <b-col>
              <h4>{{ $t('From day') }}</h4>
            </b-col>
            <b-col>
              <h4>{{ $t('From hour') }}</h4>
            </b-col>
            <b-col>
              <h4>{{ $t('From minute') }}</h4>
            </b-col>
            <b-col>
              <h4>{{ $t('From second') }}</h4>
            </b-col>
            <b-col>
              <h4>{{ $t('To day') }}</h4>
            </b-col>
            <b-col>
              <h4>{{ $t('To hour') }}</h4>
            </b-col>
            <b-col>
              <h4>{{ $t('To minute') }}</h4>
            </b-col>
            <b-col>
              <h4>{{ $t('To second') }}</h4>
            </b-col>
            <b-col>
              <h4>{{ $t('Actions') }}</h4>
            </b-col>
          </b-row>
          <b-row v-for="item in editItem.slices" v-bind:key="item.num">
            <b-col>
              <b-form-select :options="wday" v-model="item.start_wday"/>
            </b-col>
            <b-col>
              <b-form-select :options="hour" v-model="item.start_hour"/>
            </b-col>
            <b-col>
              <b-form-select :options="minuteSecond" v-model="item.start_min"/>
            </b-col>
            <b-col>
              <b-form-select :options="minuteSecond" v-model="item.start_sec"/>
            </b-col>
            <b-col>
              <b-form-select :options="wday" v-model="item.end_wday"/>
            </b-col>
            <b-col>
              <b-form-select :options="hour" v-model="item.end_hour"/>
            </b-col>
            <b-col>
              <b-form-select :options="minuteSecond" v-model="item.end_min"/>
            </b-col>
            <b-col>
              <b-form-select :options="minuteSecond" v-model="item.end_sec"/>
            </b-col>
            <b-col>
              <b-button size="sm" id="transparent" @click="deleteWDays(item)">
                <b-img :src='deleteImg'/>
              </b-button>
            </b-col>
          </b-row>
        </b-card>
        <b-form-group :label="$t('Days')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-button variant="success" style="float: right" size="sm" @click="addDays">{{ $t('Add') }}</b-button>
        </b-form-group>
        <b-card>
          <b-row>
            <b-col>
              <h4>{{ $t('Day') }}</h4>
            </b-col>
            <b-col>
              <h4>{{ $t('Mounth') }}</h4>
            </b-col>
            <b-col>
              <h4>{{ $t('Actions') }}</h4>
            </b-col>
          </b-row>
          <b-row v-for="item in editItem.days" v-bind:key="item.num">
            <b-col>
              <b-form-select :options="days" v-model="item.day"/>
            </b-col>
            <b-col>
              <b-form-select :options="month" v-model="item.month"/>
            </b-col>
            <b-col>
              <b-button size="sm" id="transparent" @click="deleteDays(item)">
                <b-img :src='deleteImg'/>
              </b-button>
            </b-col>
          </b-row>
        </b-card>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save') }}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="$refs.modalEditTimeRanges.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      daysNum: 1000000,
      wdaysNum: 1000000,
      deleteImg: require('@/assets/img/document_delete.png'),
      wday: [
        {value: 0, text: this.$i18n.t('Sunday')},
        {value: 1, text: this.$i18n.t('Monday')},
        {value: 2, text: this.$i18n.t('Tuesday')},
        {value: 3, text: this.$i18n.t('Wednesday')},
        {value: 4, text: this.$i18n.t('Thursday')},
        {value: 5, text: this.$i18n.t('Friday')},
        {value: 6, text: this.$i18n.t('Saturday')}
      ],
      hour: [
        {value: 0, text: 0},
        {value: 1, text: 1},
        {value: 2, text: 2},
        {value: 3, text: 3},
        {value: 4, text: 4},
        {value: 5, text: 5},
        {value: 6, text: 6},
        {value: 7, text: 7},
        {value: 8, text: 8},
        {value: 9, text: 9},
        {value: 10, text: 10},
        {value: 11, text: 11},
        {value: 12, text: 12},
        {value: 13, text: 13},
        {value: 14, text: 14},
        {value: 15, text: 15},
        {value: 16, text: 16},
        {value: 17, text: 17},
        {value: 18, text: 18},
        {value: 19, text: 19},
        {value: 20, text: 20},
        {value: 21, text: 21},
        {value: 22, text: 22},
        {value: 23, text: 23}
      ],
      minuteSecond: [
        {value: 0, text: 0},
        {value: 1, text: 1},
        {value: 2, text: 2},
        {value: 3, text: 3},
        {value: 4, text: 4},
        {value: 5, text: 5},
        {value: 6, text: 6},
        {value: 7, text: 7},
        {value: 8, text: 8},
        {value: 9, text: 9},
        {value: 10, text: 10},
        {value: 11, text: 11},
        {value: 12, text: 12},
        {value: 13, text: 13},
        {value: 14, text: 14},
        {value: 15, text: 15},
        {value: 16, text: 16},
        {value: 17, text: 17},
        {value: 18, text: 18},
        {value: 19, text: 19},
        {value: 20, text: 20},
        {value: 21, text: 21},
        {value: 22, text: 22},
        {value: 23, text: 23},
        {value: 24, text: 24},
        {value: 25, text: 25},
        {value: 26, text: 26},
        {value: 27, text: 27},
        {value: 28, text: 28},
        {value: 29, text: 29},
        {value: 30, text: 30},
        {value: 31, text: 31},
        {value: 32, text: 32},
        {value: 33, text: 33},
        {value: 34, text: 34},
        {value: 35, text: 35},
        {value: 36, text: 36},
        {value: 37, text: 37},
        {value: 38, text: 38},
        {value: 39, text: 39},
        {value: 40, text: 40},
        {value: 41, text: 41},
        {value: 42, text: 42},
        {value: 43, text: 43},
        {value: 44, text: 44},
        {value: 45, text: 45},
        {value: 46, text: 46},
        {value: 47, text: 47},
        {value: 48, text: 48},
        {value: 49, text: 49},
        {value: 50, text: 50},
        {value: 51, text: 51},
        {value: 52, text: 52},
        {value: 53, text: 53},
        {value: 54, text: 54},
        {value: 55, text: 55},
        {value: 56, text: 56},
        {value: 57, text: 57},
        {value: 58, text: 58},
        {value: 59, text: 59}
      ],
      days: [
        {value: 1, text: 1},
        {value: 2, text: 2},
        {value: 3, text: 3},
        {value: 4, text: 4},
        {value: 5, text: 5},
        {value: 6, text: 6},
        {value: 7, text: 7},
        {value: 8, text: 8},
        {value: 9, text: 9},
        {value: 10, text: 10},
        {value: 11, text: 11},
        {value: 12, text: 12},
        {value: 13, text: 13},
        {value: 14, text: 14},
        {value: 15, text: 15},
        {value: 16, text: 16},
        {value: 17, text: 17},
        {value: 18, text: 18},
        {value: 19, text: 19},
        {value: 20, text: 20},
        {value: 21, text: 21},
        {value: 22, text: 22},
        {value: 23, text: 23},
        {value: 24, text: 24},
        {value: 25, text: 25},
        {value: 26, text: 26},
        {value: 27, text: 27},
        {value: 28, text: 28},
        {value: 29, text: 29},
        {value: 30, text: 30},
        {value: 31, text: 31}
      ],
      month: [
        {value: 0, text: this.$i18n.t('January')},
        {value: 1, text: this.$i18n.t('February')},
        {value: 2, text: this.$i18n.t('March')},
        {value: 3, text: this.$i18n.t('April')},
        {value: 4, text: this.$i18n.t('May')},
        {value: 5, text: this.$i18n.t('June')},
        {value: 6, text: this.$i18n.t('July')},
        {value: 7, text: this.$i18n.t('August')},
        {value: 8, text: this.$i18n.t('September')},
        {value: 9, text: this.$i18n.t('October')},
        {value: 10, text: this.$i18n.t('November')},
        {value: 11, text: this.$i18n.t('December')}
      ]
    }
  },
  methods: {
    save () {
      if (!this.editItem.name || this.editItem.priority < 0) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Name or priority fields is invalid'), 'Error')
        return
      }
      for (let el of this.editItem.days) {
        if (el.month === 1 && el.day > 29) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('There is no such day in month: February'), 'Error')
          return
        }
        if (el.month === 3 && el.day === 31) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('There is no such day in month: April'), 'Error')
          return
        }
        if (el.month === 5 && el.day === 31) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('There is no such day in month: June'), 'Error')
          return
        }
        if (el.month === 8 && el.day === 31) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('There is no such day in month: September'), 'Error')
          return
        }
        if (el.month === 10 && el.day === 31) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('There is no such day in month: November'), 'Error')
          return
        }
      }
      for (let el of this.editItem.days) {
        delete el.num
      }
      this.editItem.priority = Number(this.editItem.priority)
      let response = this.editItem.tr_id !== 0
        ? this.$store.dispatch('Tariffing/UPDATE_TIME_RANGE', this.editItem)
        : this.$store.dispatch('Tariffing/CREATE_TIME_RANGE', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_TIME_RANGE')
          this.$refs.modalEditTimeRanges.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    addWDays () {
      let newWDays = {
        'end_hour': 0,
        'end_min': 0,
        'end_sec': 0,
        'end_wday': 0,
        'start_hour': 0,
        'start_min': 0,
        'start_sec': 0,
        'start_wday': 0
      }
      newWDays.num = ++this.wdaysNum
      this.editItem.slices.push(newWDays)
    },
    deleteWDays (item) {
      this.editItem.slices = this.editItem.slices.filter((el) => {
        return el.num !== item.num
      })
    },
    addDays () {
      let newDays = {
        'day': 1,
        'month': 0
      }
      newDays.num = ++this.daysNum
      this.editItem.days.push(newDays)
    },
    deleteDays (item) {
      this.editItem.days = this.editItem.days.filter((el) => {
        return el.num !== item.num
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/other/timeRanges/editModal.vue